/**
 * Actions
 * Set of consistently named constants that we can import and use across the
 * site, mostly for usage in partnership with the singleton event bus
 */

export const FLASH = "FLASH";
